import chroma from 'chroma-js';

/**
 * Determines if the background color is light based on its luminance.
 * @param backgroundColor - The background color to check.
 * @returns A boolean indicating if the background color is light.
 */
export const isBackgroundColorLight = (backgroundColor?: string): boolean => {
  if (backgroundColor === undefined) {
    return true;
  }

  if (!chroma.valid(backgroundColor)) {
    // eslint-disable-next-line no-console
    console.error(`Invalid color format: ${backgroundColor}`);
    return true;
  }

  // We are using chroma.js to determine the luminance of the color.
  // https://gka.github.io/chroma.js/#color-luminance
  // https://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
  return chroma(backgroundColor).luminance() > 0.5;
};
